// extracted by mini-css-extract-plugin
export default {"navbar":"NavigationComponent_navbar__cb21G","activeLink":"NavigationComponent_activeLink__V9RVj"};